export const FETCH_PROJECT_ACTIVITY_REQUEST = 'FETCH_PROJECT_ACTIVITY_REQUEST';
export const FETCH_PROJECT_ACTIVITY_SUCCESS = 'FETCH_PROJECT_ACTIVITY_SUCCESS';
export const FETCH_PROJECT_ACTIVITY_FAILURE = 'FETCH_PROJECT_ACTIVITY_FAILURE';
export const CLEAR_PROJECT_ACTIVITY         = 'CLEAR_PROJECT_ACTIVITY';
